module.exports = __webpack_public_path__ + "assets/7d5b38b385b49279c056d1d7579de2a0.png";